import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { inject, observer } from 'mobx-react'
import BasePage from '../../base/components/BasePage'
import Loader from '../../shared/components/Loader'

@inject('release')
@observer
export default class RootContainer extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    release: PropTypes.object.isRequired,
  }

  componentWillMount() {
    const { release } = this.props
    if (!release.length && !release.collection.length) {
      release.load()
    }
  }

  render() {

    const children = this.props.release.loading
      ? <Loader>Freigabedaten werden geladen...</Loader>
      : this.props.children

    return (
      <BasePage type="release">
        {children}
      </BasePage>
    )
  }
}



// WEBPACK FOOTER //
// ./src/release/containers/Root.js